import React from "react";
import Form from "./BroadcastForm";
import { connect } from "react-redux";
import { updateBroadcastToIcing } from "../fetchAPI/apiClient";
import moment from "moment";
const Edit = (props) => {
  let url = window.location.pathname;
  let id = url.substring(url.lastIndexOf("/") + 1);
  const onSubmit = (values) => {
    updateBroadcastToIcing(id, getPayload(values), (status, res) => {
      if (status === 200) {
        props.history.push("/broadcast-to-icing");
      } else {
        console.error("Error creating broadcast:", res);
      }
    });
  };

  const getPayload = (values) => {
    const basePayload = {
      company_id: props.profile.company_id,
      name: values.name,
      audio_id: values.source,
      remark: "",
      data_type: values.currentTab,
      is_active: values.status ? "1" : "0",
      user_id: props.profile.id,
      alarm_time: values.time,
      interval_time: moment.duration(values.distanceTime).asSeconds(),
      vehicle_list: values.currentTab === "plant" ? [] : values.vehicleSelected,
      location_list: values.currentTab === "plant" ? values.plantSelected : [],
    };

    switch (values.broadcastType) {
      case "immediately":
        return {
          ...basePayload,
          broadcast_type: "immediately",
          start_at: "",
          end_at: "",
        };

      case "schedule":
        return {
          ...basePayload,
          broadcast_type: "schedule",
          start_at: moment(values.start).format("HH:mm"),
          end_at: moment(values.end).format("HH:mm"),
        };

      case "continuous":
        return {
          ...basePayload,
          broadcast_type: "continuous",
          start_at: "",
          end_at: "",
        };

      default:
        return basePayload; // fallback กันไว้เฉยๆ
    }
  };
  return (
    <Form
      type="edit"
      match={props.match}
      onSubmit={onSubmit}
      id={id}
      companyId={props.profile.company_id}
      vehicleVisibility={props.profile.vehicle_visibility}
      locationVisibility={props.profile.location_visibility}
      location_group_visibility={props.profile.location_group_visibility}
      accessToken={props.auth.accessToken}
    />
  );
};

export default connect(
  ({ auth, auth: { profile } }) => ({
    auth,
    profile,
  }),
  {}
)(Edit);
